import Vue from 'vue'
import Mutations from '../data/mutations'
export default {
  namespaced: true,
  state: {
    projects: [],
    listView: false,
    clients: [],
    sortBy: "",
    filterBy: "",
    client: "",
    loadingProjects: false,
    loadingClients: false,
    showDetails: false
  },
  mutations: Mutations,
  actions: {
    resetForm(context) {
      context.commit('modifyContractor', "")
      context.commit('modifyProject', "")
      context.commit('modifyVehicle', "")
      context.commit('modifyProject', "")
      context.commit('resetTrips')
    }
  },
  getters: {
    getProjects: state => state.projects
  }
}